import axios from 'axios'
import * as types from '../mutation-types'

const doToArrayObject = data => {
  const term = []
  let statu = null
  const status = data
  Object.keys(status).forEach(index => {
    statu = status[index]
    term.push({ value: statu.id, text: statu.name })
  })

  return term
}

export const state = {
  loadingJobsState: true,
  statesJobsStates: [],
  errorJobsState: null,
}

export const mutations = {
  [types.GET_JOBS_STATES_LIST_START] (state) {
    state.loadingJobsState = true
    state.statesJobsStates = []
    state.errorJobsState = null
  },

  [types.GET_JOBS_STATES_LIST_SUCCESS] (state, { data }) {
    state.loadingJobsState = false
    state.statesJobsStates = doToArrayObject(data)
    state.errorJobsState = null
  },

  [types.GET_JOBS_STATES_LIST_ERROR] (state, { error }) {
    state.loadingJobsState = false
    state.statesJobsStates = []
    state.errorJobsState = error
  },
}

export const actions = {
  async getJobsStates ({ commit }) {
    try {
      commit(types.GET_JOBS_STATES_LIST_START)

      const { data } = await axios.get('/api/states_jobs/list')

      commit(types.GET_JOBS_STATES_LIST_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_JOBS_STATES_LIST_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingJobsState: state => state.loadingJobsState,
  statesJobsStates: state => state.statesJobsStates,
  errorJobsState: state => state.errorJobsState,
}
